const ROLE_ENTERPRISE_USER = "ROLE_ENTERPRISE_USER";
const ROLE_TDC1_MANAGER = "ROLE_TDC1_MANAGER";
const ROLE_TDC2_MANAGER = "ROLE_TDC2_MANAGER";

export default {
    ROLE_ENTERPRISE_USER,
    ROLE_TDC1_MANAGER,
    ROLE_TDC2_MANAGER,
}
